<template>
	<el-table
		:data="sortedFood"
		:show-header="false"
		style="width:100%">
		<el-table-column width="130">
			<template slot-scope="scope">
				<strong>{{ formatDate(scope.row.time) }}</strong> &middot;
				{{ formatTime(scope.row.time) }}
			</template>
		</el-table-column>
		<el-table-column width="120">
			<template slot-scope="scope">
				<div class="meal">
					<span class="image">
						<img :src="mealImage(scope.row.meal)">
					</span>
					{{ formatMeal(scope.row.meal) }}
				</div>
			</template>
		</el-table-column>
		<el-table-column prop="description" width="160">
			<template slot-scope="scope">
				<div class="description">{{ scope.row.description }}</div>
			</template>
		</el-table-column>
		<el-table-column>
			<template slot-scope="scope">
				<div :set="nutrientObj = findNutrient(scope.row.nutrient, scope.row.serving_size, scope.row.base_value, scope.row.quick_add)" class="nutrient-row">
					<span class="nutrient-cell">
						<span class="small-head">Serving Size</span>
						{{ scope.row.serving_unit || 1 }}{{ scope.row.base_value ? ', ' + scope.row.base_value + ' g' : '' }}
					</span>
					<span class="nutrient-cell">
						<span class="small-head">No. of Servings</span>
						{{ scope.row.serving_size }}
					</span>
					<span v-if="nutrientObj.energy" class="nutrient-cell">
						<span class="small-head">Energy</span>
						{{ Math.round(nutrientObj.energy.value) }} cal
					</span>
					<span v-if="nutrientObj.carbohydrates" class="nutrient-cell nutrient-carb">
						<span class="small-head">Carbs</span>
						<span>{{ Math.round(nutrientObj.carbohydrates.value) }} g <span v-if="nutrientObj.sugar">({{ Math.round(nutrientObj.sugar.value) }} g sugar)</span></span>
					</span>
					<span v-if="nutrientObj.protein" class="nutrient-cell">
						<span class="small-head">Protein</span>
						{{ Math.round(nutrientObj.protein.value) }} g
					</span>
					<span v-if="nutrientObj.fat" class="nutrient-cell">
						<span class="small-head">Fat</span>
						{{ Math.round(nutrientObj.fat.value) }} g
					</span>
				</div>
			</template>
		</el-table-column>
		<!-- <el-table-column width="100">
			<template slot-scope="scope">
				<div v-bind:class="['size', 'v-' + (scope.row.size + 1)]">
					<div class="icon">
						<i :class="(scope.row.meal === 3) ? 'el-icon-water-cup' : 'el-icon-food'"></i>
					</div>
					<label>{{ formatSize(scope.row.size) }}</label>
				</div>
			</template>
		</el-table-column>
		<el-table-column width="200">
			<template slot-scope="scope">
				<div v-if="scope.row.health != null"
					 v-bind:class="['health', 'v-' + (scope.row.health + 1)]">
					<div class="star">
						<i class="el-icon-star-on"></i>
						<i v-for="star in scope.row.health" class="el-icon-star-on"></i>
					</div>
					<label>{{ formatHealth(scope.row.health) }}</label>
				</div>
			</template>
		</el-table-column> -->
		
	</el-table>
</template>

<script>
import FoodAnalysis from '.'
import { NUTRIENTS } from './'

export default {
	name: 'patient-lifestyle-card-food-table',
	extends: FoodAnalysis,

	methods: {
		/**
		 * Return an object of nutrient to display with values mutiplied to serving size
		 */
		findNutrient(rowData, servingSize, basevalue, quick_add) {
			if(rowData && Array.isArray(rowData))
				return rowData
					.reduce((acc, nutrient) => {
						const nutrientValue = Object.entries(NUTRIENTS).find((nutrientPair) => nutrientPair[1].code === nutrient.id)
						if(nutrientValue && nutrient.hasOwnProperty('value'))
							acc[nutrientValue[0]] = { ...nutrient, value: nutrient.value / 100 * (basevalue || 100) * (servingSize || 1) }
						else if(nutrientValue && nutrient.hasOwnProperty('value'))
							acc[nutrientValue[0]] = {...nutrient}
						return acc
					}, {})
			return {}
		}
	}
}
</script>

<style lang="scss" scoped>

$background: rgb(229, 240, 248);
$red: #f95a5a;
$yellow: #f5a623;
$green: #7ec635;

h6 {
	font-size: 12px;
	line-height: 24px;
	margin: 0;
	padding-left: 10px;
	color: #7f7f7f;
}
.meal {
	display: inline-block;
	padding: 0px 8px;
	background: $background;
	font-size: 14px;
	line-height: 24px;
	font-weight: 500;
	text-transform: capitalize;
	border-radius: 12px;

	.image {
		float: left;
		margin: 2px 5px 2px -5px;
		border-radius: 50%;
		width: 20px;
		height: 20px;
		background: white;

		img {
			width: 16px;
			height: 16px;
			margin: 2px;
		}
	}
}
.health.v-1 {
	color: $red;
}
.health.v-2 {
	color: $yellow;
}
.health.v-3 {
	color: $green;
}
.health {
	line-height: 12px;
	.star {
		float: left;
		width: 50px;
		font-size: 14px;
		line-height: 22px;
		text-align: right;
		padding-right: 5px;
	}
	label {
		display: inline-block;
		font-size: 14px;
		line-height: 22px;
		text-transform: capitalize;
	}
}
.size {
	line-height: 12px;
	.icon {
		float: left;
		font-size: 14px;
		line-height: 22px;
		opacity: 0.8;
		margin-top: 0px;
		width: 30px;
		text-align: center;
	}
	label {
		display: inline-block;
		font-size: 14px;
		line-height: 22px;
		text-transform: capitalize;
	}
}
.size.v-2 {
	.icon {
		font-size: 18px;
	}
}
.size.v-3 {
	.icon {
		font-size: 22px;
	}
}
.description {
	font-size: 14px;
	font-weight: 500;
	line-height: 18px;
	max-width: 500px;
}
.nutrient-row{
	display: flex;
	.nutrient-cell{
		display: flex;
		flex-direction: column;
		width: 80px;
		&.nutrient-carb{
			width: 120px;
		}
		.small-head{
			font-size: 10px;
			line-height: 10px;
		}
	}
}

</style>
